import { useTranslation } from 'react-i18next';
import type { AppointmentStatus } from '@shared/constants/index.ts';
import { classes } from '../ui.tsx';
import { APPOINTMENT_TONES } from './format.ts';

export function AppointmentBadge({ status }: { status: AppointmentStatus }) {
  const { t } = useTranslation();
  return (
    // The label carries the meaning; color only reinforces it (spec §27).
    <span className={classes('badge', APPOINTMENT_TONES[status])}>{t(`schedule.appointmentStatus.${status}`)}</span>
  );
}
